import { Observable } from "rxjs";

export interface WSimpleOption {
  label: string; value: any;
}
export interface WOption {
  label?: string;
  labelAsync?: Observable<any>;
  value?: any; // can be missing or be string or object
  label2?: string;
  tip?: string;
  tip2?: string;
  disabled?: boolean;
  info?: string;
  tipInfo?: string;
  nestedOptions?: (string | WOption)[];
  expanded?: boolean; // used if tree table (in this case value should be WOption[])
} 
export type WOptionOrString = WOption | string;
export interface WOptionEvent {
  event: Event; source: WOptionOrString; value: any; selected: WOptionOrString | WOptionOrString[];
}
export const getOptionValue = (option: WOptionOrString): any => {
  return !option || typeof option === 'string' ? option : option.value;
};
